<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Start cash tracking</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="start()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid *ngIf="cash_tracking_session_floats && cash_tracking_session_floats.length != 0" class="form">
        <ion-row>
            <ion-col>
                <ion-grid *ngFor="let float of cash_tracking_session_floats" class="fieldset">
                    <ion-row *ngIf="cash_tracking_session_floats.length > 1">
                        <ion-col>
                            <h3>{{float.title}}</h3>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="tel" inputmode="decimal" maxlength="10" labelPlacement="stacked" fill="outline" [(ngModel)]="float.price">
                                <div slot="label">Float<ion-text *ngIf="cash_tracking_session_floats.length > 1" class="optional">optional</ion-text></div>
                            </ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="3" labelPlacement="stacked" fill="outline" [(ngModel)]="float.note">
                                <div slot="label">Note<ion-text class="optional">optional</ion-text></div>
                            </ion-textarea>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>